import { VideoModel } from "@courses-pm2/api/src/ts/models";
import { Engine } from "@courses-pm2/api/src/ts/utils";

import { parseCaptionedContentElement } from "@courses-pm2/api/src/ts/parser/parseCaptionedContentElement";

/**
 * Helper that parses <Video /> elements in the response from the pm2 backend.
 */
export async function parseVideo({ node, portalId, engine }: {
    node: Element;
    portalId: string;
    engine?: Engine;
}): Promise<VideoModel> {
    // Announce that a model has been identified if possible
    if (engine) {
        engine.announce(VideoModel);
    }

    const twentyThreeVideo = node.querySelector("TwentyThreeVideo");

    return new VideoModel({
        engine,
        portalId,

        // Extract basic configurations
        photoId: twentyThreeVideo?.querySelector("Id")?.textContent ?? "",
        token: twentyThreeVideo?.querySelector("Token")?.textContent ?? "",
        displayInternalInfo: node.getAttribute("showOverlay") === "true",

        // Push basic configurations for a captioned content element
        ...parseCaptionedContentElement(node),
    });
}
